import Icon from '../components/Icon.vue'

Icon.register({"unlock":{"width":1664,"height":1792,"paths":[{"d":"M1664 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/unlock.js
// module id = 1382
// module chunks = 0